// extracted by mini-css-extract-plugin
module.exports = {"container":"IconButton_container__2E_Ls","icon":"IconButton_icon__3yKMY"};